<template>
  <div>
    <div class="title-h4">패턴 설정</div>
    <el-form ref="userPattern" :model="patternInfo" label-position="top" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="패턴명" label-width="120px" prop="patternName">
            <el-input v-model="patternInfo.patternName" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="저장소" label-width="120px">
            {{indexInfo.dataindexName}}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="패턴 아이디" prop="patternId">
          <el-input v-model="patternInfo.patternId"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="날짜 패턴" prop="patternTimestamp">
          <el-input v-model="patternInfo.patternTimestamp"></el-input>
        </el-form-item>
      </el-row>
      <el-row class="mr-b25">
        <el-form-item label="패턴 설명">
          <el-input v-model="patternInfo.patternDesc" type="textarea"></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-row class="vertical-center-box title-bar">
          <div class="title-h4 mr-r4">
            패턴 매핑 설정
          </div>
          <span class="setting-addel mr-r4">
            <el-button size="mini" @click="onChangeCheckedFlag('Y')"><i class="fas fa-check-square" /></el-button>
            <el-button size="mini" @click="onChangeCheckedFlag('N')"><i class="far fa-square" /></el-button>
          </span>
        </el-row>
          <el-table-wrapper :column-default="columnDefault" border :data="patternField" :columns="mappingColumns" :pagination="false"
            :show-custom-header="false" ref="mappingTable" header-align="center" highlight-current-row>
            <template slot-scope="scope" slot="mapping-slot">
              <el-checkbox v-model="scope.row.mappingFlag" true-label="Y" false-label="N"></el-checkbox>
            </template>
          </el-table-wrapper>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { columnDefault } from '@/constants/table';

export default {
  name: 'WParsingPatternBasicSetting',
  props: {
    patternInfo: {
      type: Object,
      default: null,
    },
    indexInfo: {
      type: Object,
      default: null,
    },
    patternField: {
      type: Array,
    },
  },
  data() {
    return {
      mappingColumns: [
        {
          headerAlign: 'center',
          align: 'center',
          label: '매핑',
          width: '70',
          scopedSlot: 'mapping-slot',
          prop: 'mappingFlag',
        },
        {
          prop: 'fieldName',
          label: '필드명',
        },
      ],
      mappingData: [],
      columnDefault,
      rules: {
        patternId: [
          { required: true, message: '필수 정보입니다.', trigger: 'blur' },
        ],
        patternName: [
          { required: true, message: '필수 정보입니다.', trigger: 'blur' },
        ],
        patternTimestamp: [
          { required: true, message: '필수 정보입니다.', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    onChangeCheckedFlag(flag) {
      this.patternField.forEach((item) => {
        item.mappingFlag = flag;
      });
    },
    /**
     * 다음 버튼 클릭 시 validation 체크
     * @author leesy918
     * @return {[type]} [description]
     */
    nextStep() {
      this.$refs.userPattern.validate().then((success) => {
        if (success) {
          this.$emit('increaseActiveStep');
        }
      }).catch(() => {});
    },
    resetField() {
      this.$refs.userPattern.resetFields();
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/log-analysis/Collect/LogIndex/components/ParsingPatternBasicSetting.vue